import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import { FormSpy } from 'react-final-form';

import {
  FormInput,
  FormLabel,
  FormSelect,
  FormIconChooser,
  FormRadio,
  FormDateInput,
  BaseForm,
  FormInputHolder,
} from './form';

import { Button, SecondaryButton } from './buttons';
import { required } from '../helpers/formValidators';
import babyIcons from './icons/babyIcons';
import { Error } from "./form/BaseForm";
import './BabyEdit.css';


function BabyEdit(props) {
  const {
    onSubmit,
    onAddAnotherClicked,
    t,
    error,
    initialValues
  } = props;

  const { colorScheme } = props.initialValues;

  return (
    <BaseForm
      className="baby-edit"
      onSubmit={onSubmit}
      initialValues={initialValues}
    >
      <h2>Baby Information Form</h2>

      <div className="baby-edit__row">
        <div className="baby-edit__field">
          <FormInput
            labelRenderer={() => <FormLabel>{t('baby.name')}</FormLabel>}
            name="name"
            validate={required}
          />
        </div>
        <div className="baby-edit__field">
          <FormLabel>{t('baby.sex')}</FormLabel>
          <FormSelect
            options={[
              { value: 'M', label: t('baby.male') },
              { value: 'F', label: t('baby.female') },
              { value: 'O', label: t('baby.other') }
            ]}
            name="sex"
            validate={required}
          />

          <Error name="sex" />

        </div>
      </div>
      <div className="baby-edit__row">
        <div className="baby-edit__field">
          <FormDateInput
            labelRenderer={() => <FormLabel>{t('baby.birthDate')}</FormLabel>}
            name="birthDate"
            validate={required}
            // dateFormat='y-MM-dd'
          />
        </div>
        <div className="baby-edit__field">
          <FormDateInput
            labelRenderer={() => <FormLabel>{t('baby.dueDate')}</FormLabel>}
            name="dueDate"
            validate={required}
            // dateFormat='y-MM-dd'
          />
        </div>
        <div className="baby-edit__field">
          <FormDateInput
            labelRenderer={() => (
              <FormLabel note={t('baby.optional')}>{t('baby.admissionDate')}</FormLabel>
            )}
            name="admissionDate"
            // dateFormat='y-MM-dd'
          />
        </div>
      </div>
      <div className="baby-edit__row">
        <div className="baby-edit__field">
          <FormInput
            labelRenderer={() => (
              <FormLabel note={t('baby.optional')}>{t('baby.deliveryType')}</FormLabel>
            )}
            name="deliveryType"
          />
        </div>
        <div className="baby-edit__field">
          <FormInput
            labelRenderer={() => <FormLabel note={t('baby.optional')}>{t('baby.diagnosis')}</FormLabel>}
            name="diagnosis"
          />
        </div>
        <div className="baby-edit__field">
          <FormInput
            labelRenderer={() => (
              <FormLabel note={t('baby.optional')}>{t('baby.room')}</FormLabel>
            )}
            name="room"
          />
        </div>
      </div>
      <div className="baby-edit__select-icon-label">
        <FormLabel>{t('baby.selectAnIcon')}</FormLabel>
      </div>
      <FormIconChooser>
        {[1, 2, 3, 4].map(number => (
          <FormRadio
            key={number}
            name="icon"
            value={`${colorScheme}${number}`}
            imageSrc={babyIcons[`${colorScheme}${number}`]}
          />
        ))}
      </FormIconChooser>
      <div className="baby-edit__error-container">
        {error && <p className="error-text">{t(error)}</p>}
      </div>

      <FormSpy
        subscription={{ submitting: true }}
      >
        {({ submitting }) => {
          return (
            <FormInputHolder>
              <SecondaryButton
                loading={submitting}
                disabled={submitting}
                colorScheme="blue"
                label={t('baby.addAnotherBaby')}
                onClick={onAddAnotherClicked}
              />
              <Button
                loading={submitting}
                disabled={submitting}
                colorScheme="red"
                label={t('baby.saveContinue')}
                className="last"
              />
            </FormInputHolder>
          )
        }}
      </FormSpy>
    </BaseForm>
  );
}

BabyEdit.defaultProps = {
  error: null
};

BabyEdit.propTypes = {
  initialValues: PropTypes.shape({
    colorScheme: PropTypes.string.isRequired
  }).isRequired,
  submitting: PropTypes.bool,
  onAddAnotherClicked: PropTypes.func,
  error: PropTypes.string,
  t: PropTypes.func.isRequired
};

export default translate()(BabyEdit);



// WEBPACK FOOTER //
// ./src/components/BabyEdit.js